/* Phero Mànte — Upsell card add-to-cart.
   One delegated listener for all cards (section + block). The drawer
   (pm-cart-drawer) listens for `cart:added` and refreshes + opens itself. */
(function () {
  if (window.__pmUpsellBound) return;
  window.__pmUpsellBound = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-pm-upsell-add]');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (btn.dataset.state === 'loading') return;

    const variantId = btn.getAttribute('data-pm-upsell-add');
    if (!variantId) return;

    btn.dataset.state = 'loading';

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      // Re-render drawer + header so pm-cart-drawer can swap them in.
      fd.append('sections', 'pm-cart-drawer,header');

      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'add failed');

      btn.dataset.state = 'success';

      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      try {
        if (window.PUB_SUB_EVENTS && window.publish) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pm-upsell-card', productVariantId: variantId });
        }
      } catch (_) {}

      setTimeout(function () { btn.dataset.state = ''; }, 1500);
    } catch (err) {
      console.error('[pm-upsell]', err);
      btn.dataset.state = '';
    }
  });
})();
